import { Toolbar } from '@components/Toolbar';
import type { IUseAccess } from '@hooks/useAccess';
import { Button, cnMixSpace } from '@uikit';
import { formatDateToLocale } from '@utils';

import type { RatioIdType } from '../../../types';
import Styles from '../../catalogRatios.module.css';

type TCatalogRatiosToolbarProps = {
    handleOpenCreateOrEditDialog: (ratioId: RatioIdType) => () => void;
    handleOpenHistory: () => void;
    catalogRatiosRules: IUseAccess['catalogRatios'];
    updatedAt: Date;
};

export const CatalogRatiosToolbar = ({
    handleOpenCreateOrEditDialog,
    handleOpenHistory,
    catalogRatiosRules,
    updatedAt,
}: TCatalogRatiosToolbarProps) => (
    <Toolbar>
        <div className={Styles.toolbarContainer}>
            <div className={Styles.flexCenter}>
                <Button
                    label="Создать коэффициент"
                    onClick={handleOpenCreateOrEditDialog(null)}
                    size="s"
                    view="secondary"
                    disabled={!catalogRatiosRules?.canCreate}
                />

                <Button
                    label="Просмотреть историю изменений"
                    onClick={handleOpenHistory}
                    size="s"
                    className={cnMixSpace({ mL: 's' })}
                    view="secondary"
                />
            </div>
            <div className={Styles.rightSideWrapper}>
                <span>Обновлён: {formatDateToLocale(updatedAt, true)}</span>
            </div>
        </div>
    </Toolbar>
);

CatalogRatiosToolbar.displayName = 'CatalogRatiosToolbar';
